import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { calculateLineHeightClosestChild } from './utils';
export function useIsMultiLine(ref, needCalculate) {
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isMultiLine = _React$useState2[0],
    setIsMultiLine = _React$useState2[1];
  React.useEffect(function () {
    if (ref.current && needCalculate) {
      var element = ref.current;
      var lineHeight = calculateLineHeightClosestChild(element);
      setIsMultiLine(parseInt(window.getComputedStyle(element).height, 10) > lineHeight);
    }
  }, [ref, needCalculate]);
  return isMultiLine;
}